import SearchFormInput from './SearchFormInput';

export default SearchFormInput;
